import * as Animate from "react-reveal";

const steps = [
  {
    number: "01",
    title: "Apply",
    desc: "Share your expertise, experience and preferred teaching areas.",
  },
  {
    number: "02",
    title: "Expertise review",
    desc: "The Utiva faculty team reviews your background and practical fit.",
  },
  {
    number: "03",
    title: "Conversation or assessment",
    desc:
      "Discuss teaching approach, communication, availability and programme alignment.",
  },
  {
    number: "04",
    title: "Onboarding",
    desc:
      "Prepare with the faculty team around curriculum, delivery and learner experience.",
  },
  {
    number: "05",
    title: "Start teaching",
    desc:
      "Join an appropriate programme when the right faculty opportunity is available.",
  },
];

const TrainerJourneySection = () => {
  return (
    <section
      className="bg-hire-tint-blue py-16 md:py-20 lg:py-24 px-4"
      id="journey"
    >
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            The trainer journey
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-xl tracking-[-0.03em] text-primary">
              From application to your first learner experience.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              Every step helps both you and Utiva confirm fit before you enter a
              programme.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid gap-4">
          {steps.map((step) => (
            <Animate.Fade bottom key={step.number}>
              <div className="flex items-start gap-5 bg-white rounded-2xl border border-hire-line p-6">
                <span className="w-9 h-9 flex-none rounded-full bg-secondary text-primary grid place-items-center font-poppins text-sm font-extrabold">
                  {step.number}
                </span>
                <div>
                  <h3 className="font-poppins font-extrabold text-lg text-primary mb-1.5">
                    {step.title}
                  </h3>
                  <p className="text-gray font-poppins text-sm leading-relaxed m-0">
                    {step.desc}
                  </p>
                </div>
              </div>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrainerJourneySection;
